export default __webpack_public_path__ + "static/media/equal.8a9697db.svg";